import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const removeChatRoom = async (chatRoomIds: string[]) => {
  const response = await mutationExecute({
    variables: {
      chatRoomIds,
    },
    mutation: graphql(`
      mutation CloseChat($chatRoomIds: [String!]!) {
        closeChat(chatRoomIds: $chatRoomIds)
      }
    `),
  });

  return response.data?.closeChat ?? false;
};
